import { Product } from '~app/modules/account/modules/buy-again/models';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GATrackingEventType
} from '~shared/modules/ga-tracking/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { GaTrackingHelpersService } from '../../utils/ga-tracking-helpers.service';
import { NUMBER_1 } from '~shared/constants';

export class GaTrackingViewItemsListShoppingListEventModel {

  constructor(
    private products: Product[],
    private priceType: PriceTypes,
    private previousProductsShownLength = 0,
    private isBlackDealsEnabled: boolean,
    private item_list_name: string,
    private pageUrl: string,
    private currency: string,
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewItemList;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GATrackingEventType.ViewItemList,
      gtmCustom: {
        ecommerce: {
          item_list_name: this.item_list_name,
          currency: this.currency,
          items: this.products.map((product: Product, index: number): any => {
            return {
              ...GaTrackingHelpersService.getItemObjectForGA4(
                product,
                product.bestOffer,
                this.priceType,
                false,
                GaTrackingHelpersService.getCategoriesFromBreadcrumbsFull(product.breadcrumbsFull),
                false,
                product.quantity ? product.quantity : NUMBER_1,
                product.EECLabel,
                this.pageUrl,
                this.isBlackDealsEnabled
              ), 
              index: this.previousProductsShownLength + index + 1,
              item_offer_id: product.bestOffer?.id
            }
          },

          ),
        },
      }
    };
  }
}
